import React, { useContext, useEffect } from "react";
import { Grid, Paper, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import MomentUtils from "@date-io/moment";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

// Contexts
import DiscountContext from "../../../../context/discounts/DiscountContext";

// Components
import StoresInclude from "./StoresInclude";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginBottom: "1rem",
    marginLeft: "8px",
    height: 460,
  },
  paperBox: {
    padding: "0.5rem",
  },
  field: {
    padding: theme.spacing(1, 1, 0, 1),
  },
  button: {
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
  },
}));

const DiscountForm = ({ formType, handleChange, handleDateChange }) => {
  const classes = useStyles();

  const {
    list_type,
    default_form_data,
    default_form_error,
    selected_discount,
    form_data,
    form_error,
    setFormData,
    setFormError,
  } = useContext(DiscountContext);

  useEffect(() => {
    if (formType === "Create") {
      setFormData(default_form_data);
      setFormError(default_form_error);
    }
  }, []);

  useEffect(() => {
    if (selected_discount && formType === "Edit") {
      let data = JSON.parse(JSON.stringify(selected_discount));

      // Convert Date Selected Format (YYYY:MM:DD hh:mm:ss > YYYY:MM:DD)
      let startdate = data.discount_startdate.slice(0, 10);
      let expiredate = data.discount_expiredate.slice(0, 10);

      setFormData({
        discount_name: data.discount_name,
        discount_type: data.discount_type,
        discount_amount: data.discount_amount.toFixed(2),
        discount_startdate: startdate,
        discount_expiredate: expiredate,
        discount_include: data.discount_include,
        spend_threshold: data.spend_threshold.toFixed(2),
      });
      setFormError(default_form_error);
    }
  }, [selected_discount]);

  return (
    <Paper className={classes.paper}>
      <Grid
        container
        justifyContent="flex-start"
        alignItems="flex-start"
        className={classes.paperBox}
      >
        <Grid item xs={4}>
          {" "}
          {/* Name */}{" "}
          <Grid item xs={12} className={classes.field}>
            <TextField
              required
              fullWidth
              size="small"
              margin="dense"
              label="Discount Code"
              id="discount_name"
              name="discount_name"
              value={form_data.discount_name}
              onChange={handleChange}
              error={form_error.discount_name ? true : false}
              helperText={form_error.discount_name}
            />{" "}
          </Grid>
          {/* Type */}{" "}
          <Grid item xs={12} className={classes.field}>
            <TextField
              required
              fullWidth
              select
              SelectProps={{
                native: true,
              }}
              size="small"
              margin="dense"
              label="Discount Type"
              id="discount_type"
              name="discount_type"
              value={form_data.discount_type}
              onChange={handleChange}
            >
              {list_type.map((each, index) => {
                return (
                  <option key={index} value={each}>
                    {" "}
                    {each}{" "}
                  </option>
                );
              })}{" "}
            </TextField>{" "}
          </Grid>
          {/* Amount */}{" "}
          <Grid item xs={12} className={classes.field}>
            <TextField
              required
              fullWidth
              size="small"
              margin="dense"
              label="Discount Amount"
              id="discount_amount"
              name="discount_amount"
              value={form_data.discount_amount}
              onChange={handleChange}
              error={form_error.discount_amount ? true : false}
              helperText={form_error.discount_amount}
            />{" "}
          </Grid>
          {/* Spend Threshold */}{" "}
          <Grid item xs={12} className={classes.field}>
            <TextField
              required
              fullWidth
              size="small"
              margin="dense"
              label="Spend Threshold"
              id="spend_threshold"
              name="spend_threshold"
              value={form_data.spend_threshold}
              onChange={handleChange}
              error={form_error.spend_threshold ? true : false}
              helperText={form_error.spend_threshold}
            />{" "}
          </Grid>
          {/* Start Date */}{" "}
          <Grid item xs={12} className={classes.field}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <KeyboardDatePicker
                required
                fullWidth
                disableToolbar
                autoOk={true}
                variant="inline"
                margin="dense"
                format="YYYY-MM-DD"
                label="Start Date"
                id="discount_startdate"
                name="discount_startdate"
                value={form_data.discount_startdate}
                onChange={(date) => handleDateChange("start", date)}
                error={form_error.discount_startdate ? true : false}
                helperText={form_error.discount_startdate}
                KeyboardButtonProps={{
                  className: classes.button,
                }}
              />{" "}
            </MuiPickersUtilsProvider>{" "}
          </Grid>
          {/* Expiry Date */}{" "}
          <Grid item xs={12} className={classes.field}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <KeyboardDatePicker
                required
                fullWidth
                disableToolbar
                autoOk={true}
                variant="inline"
                margin="dense"
                format="YYYY-MM-DD"
                label="Expire Date"
                id="discount_expiredate"
                name="discount_expiredate"
                value={form_data.discount_expiredate}
                onChange={(date) => handleDateChange("expire", date)}
                error={form_error.discount_expiredate ? true : false}
                helperText={form_error.discount_expiredate}
                KeyboardButtonProps={{
                  className: classes.button,
                }}
              />{" "}
            </MuiPickersUtilsProvider>{" "}
          </Grid>{" "}
        </Grid>
        {/* Stores Include */}{" "}
        <Grid item xs={8}>
          <StoresInclude />
        </Grid>{" "}
      </Grid>{" "}
    </Paper>
  );
};

export default DiscountForm;
